import { CommunityCardAnswer } from "components/community-search/community-card/community-card-answer";
import { LayoutItems, LayoutSectionResult } from "components/layout/layout-items";
import { AdvancedSearchEntityType, CommunityCardBasicsFragment } from "generated/graphql";
import React from "react";
import { useBridgeQuestionsForCurrentRegion } from "store/selectors/bridge";
import { useVisibleUsers } from "store/selectors/hooks";

type AnswerRow = CommunityCardBasicsFragment["answers"][0];

interface AnsweredCustomFieldsProps {
    entityType: AdvancedSearchEntityType;
    layoutSection: LayoutSectionResult | null;
    answers: AnswerRow[];
}

export const AnsweredCustomFields: React.FC<AnsweredCustomFieldsProps> = props => {
    const { entityType, layoutSection, answers } = props;

    const users = useVisibleUsers();
    const questions = useBridgeQuestionsForCurrentRegion(entityType);
    const layoutItems = (layoutSection?.layoutItems ?? []).filter(
        item => item.questionId,
    );

    if (layoutItems.length === 0) {
        return null;
    }

    return (
        <LayoutItems
            getAnswers={() => answers}
            renderAnswer={(question, answer) => (
                <CommunityCardAnswer question={question} answer={answer} users={users} />
            )}
            renderStandardField={() => null}
            questions={questions}
            layoutItems={layoutItems}
            fieldMetadataList={[]}>
            {(items, getTitle, renderValue) => {
                const rows = items
                    .map(item => ({ item, value: renderValue(null, item) }))
                    .filter(row => row.value);

                if (rows.length === 0) {
                    return null;
                }

                return (
                    <div className="flex flex-col items-start gap-x-5 gap-y-1.5 sm:flex-row sm:flex-wrap sm:items-baseline">
                        {rows.map(row => (
                            <div
                                key={row.item.id}
                                className="flex min-w-0 max-w-xs items-baseline gap-1.5">
                                <dt className="flex-shrink-0 text-xs text-gray-500">
                                    {getTitle(row.item)}
                                </dt>
                                <dd className="min-w-0 truncate text-sm text-gray-900">
                                    {row.value}
                                </dd>
                            </div>
                        ))}
                    </div>
                );
            }}
        </LayoutItems>
    );
};
